import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import HomeSVG from "./SVG/HomeSVG";
import MeSVG from "./SVG/MeSVG";
import LightSVG from "./SVG/LightSVG";
import MailSVG from "./SVG/MailSVG";
import myContext from "../Context/myContext";

const Header = () => {
    const context = useContext(myContext);
    var button = null;

    if (context.AdminPresent) {
        button = (
            <li className="nav-item">
                <NavLink className="nav-link" to="/admin">
                    پنل مدیریت
                </NavLink>
            </li>
        );
    }

    return (
        <>
            <div className="navbar2 d-block d-md-none">
                <div className="row">
                    <NavLink exact className="col-3 text-center" to="/">
                        <HomeSVG />
                    </NavLink>
                    <NavLink className="col-3 text-center pd7" to="/about">
                        <MeSVG />
                    </NavLink>
                    <NavLink className="col-3 text-center pd7" to="/service">
                        <LightSVG />
                    </NavLink>
                    <NavLink className="col-3 text-center pd7" to="/contact">
                        <MailSVG />
                    </NavLink>
                </div>
            </div>
            <nav className="navbar sticky-top navbar-expand-md navbar-light bg-light d-none d-md-block">
                <div className="container">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item active">
                                <a className="nav-link btn_hover" href="tel:+989384506455">
                                    تماس بگیر
                                </a>
                            </li>
                            <li className="nav-item">
                                <NavLink exact className="nav-link" to="/">
                                    صفحه نخست
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/about">
                                    درباره من
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="service">
                                    خدمات
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/contact">
                                    ارتباط با من
                                </NavLink>
                            </li>
                            {button}
                        </ul>
                    </div>
                    <p id="NavLogoId">
                        AB<span>01</span>FAZL
                    </p>
                </div>
            </nav>
        </>
    );
};

export default Header;
